import { useState, useEffect, type JSX } from 'react';
import Box from '@mui/material/Box';
import { modalClasses } from '../modal.classes';
import { useModalBodyFullScrollStyles } from './modalBody.styles';
import { BaseProps, FullScrollProps } from './modalBody';

type ModalBodyFullScrollProps = Omit<FullScrollProps, 'scrollType'> & BaseProps;

/**
 * The scrollable content area of the Modal.
 * The entire modal body is scrollable with specific styles applied.
 */
export const ModalBodyFullScroll = ({
  styles,
  withFooter = true,
  onRefChanged,
  children,
}: ModalBodyFullScrollProps): JSX.Element => {
  const [modalBody, setModalBody] = useState<HTMLDivElement | null>(null);
  const css = useModalBodyFullScrollStyles(modalBody, withFooter);

  useEffect(() => {
    if (modalBody) {
      onRefChanged?.(modalBody);
    }
  }, [modalBody]);

  return (
    <Box
      ref={setModalBody}
      className={modalClasses.body}
      style={styles}
      css={css.body}
    >
      {children}
    </Box>
  );
};
